export const submitHash = async ({
  apiClient,
  hash,
  history,
  successPath,
  setApplicationResult,
  setError,
  termsStep,
}) => {
  const response = await apiClient.post(
    "verify-prequal-application",
    { hashString: hash },
    true
  );

  if (!response) {
    setApplicationResult({ result: "ERROR" });
    return;
  }

  if (response.Error) {
    setError("ssn", {
      type: "custom",
      message: response.Error,
    });
    return;
  }

  if (response.Success === true) {
    setApplicationResult({
      product_code: response.Payload.ProductCode,
      ref_number: response.Payload.ApplicantId,
      credit_limit: response.Payload.CreditLimit,
      result: "APPROVED",
    });
    termsStep(true);
    history.push(`${successPath}${window.location.search}`);
    return;
  }

  setApplicationResult({ result: "ERROR" });
};
